import { useAppSelector } from "@/hooks/redux"
import { Button, ButtonProps } from "antd"

const ProductColorButton = (props: ButtonProps) => {
  const colorsSelectionSetting = useAppSelector(state => state.store.store_setting.data.colors_selection)

  return (
    <Button
      {...props}
      htmlType="button"
      style={{
        minHeight: `${colorsSelectionSetting.width / 10}rem`,
        minWidth: `${colorsSelectionSetting.height / 10}rem`,
        ...(!!colorsSelectionSetting.border_width ? {
          borderWidth: colorsSelectionSetting.border_width,
          borderColor: colorsSelectionSetting.border_color,
        } : {}),
        fontSize: `${colorsSelectionSetting.size / 10}rem`,
        fontFamily: colorsSelectionSetting.font_name ? `${colorsSelectionSetting.font_name} !important` : undefined,
        color: colorsSelectionSetting?.color,
        ...(colorsSelectionSetting.decorator === 'bold' ? {
          fontWeight: 'bold'
        } : {}),
        ...(colorsSelectionSetting.decorator === 'italic' ? {
          fontStyle: 'italic'
        } : {}),
        ...(colorsSelectionSetting.decorator === 'underline' ? {
          textDecoration: 'underline'
        } : {}),
        ...props.style
      }}
      type="primary"
      size="large"
      shape={"round"}
    />
  )
}

export default ProductColorButton